import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Attribute, Component, ContentChildren, Input, OnInit, Optional, QueryList } from '@angular/core';
import { matExpansionAnimations, MatExpansionPanelState } from '@angular/material/expansion';
import { AccordionHeaderComponent } from './accordion-header/accordion-header.component';
import { AccordionRowComponent } from './accordion-row/accordion-row.component';

@Component({
  selector: 'ff-accordion-table',
  templateUrl: './accordion-table.component.html',
  styleUrls: ['./accordion-table.component.scss'],
  animations: [
    trigger('bodyExpansion', [
      state('collapsed', style({ visibility: 'hidden', height: 0 })),
      state('expanded', style({ visibility: 'visible' })), // Create the transition
    ]),
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(-90deg)' })),
      state('expanded', style({ transform: 'rotate(0deg)' })),
      transition('expanded <=> collapsed', animate('225ms')), // Create the transition
    ]),]
})
export class AccordionTableComponent implements OnInit, AfterViewInit {
  // Table header style
  @Input() class: "table-clear" | "table-medium" | "table-dark" = "table-medium";

  /// List of header child component elements
  public headers: AccordionHeaderComponent[] = [];
  @ContentChildren(AccordionHeaderComponent) headerTemplates: QueryList<AccordionHeaderComponent>;
  
  /// List of row child elements
  public rows: AccordionRowComponent[] = [];
  @ContentChildren(AccordionRowComponent) rowTemplates: QueryList<AccordionRowComponent>;
  
  // If a given row body is expanded or not
  rowExpanded: {[id:string]: Boolean} = {};
  
  // List of columns to show
  displayedDataColumnsList: string[] = [];
  
  // If it should have accordion functionality
  accordion: boolean;

  // If it should have checkbox on each row
  checkbox: boolean;

  constructor(
    @Optional() @Attribute('accordion') accordion: boolean,
    @Optional() @Attribute('checkbox') checkbox: boolean,
  ) {
    
    this.accordion = !(accordion === null);
    if (this.accordion) this.displayedDataColumnsList.push('expand');

    this.checkbox = !(checkbox === null);
    if (this.checkbox) this.displayedDataColumnsList.push('checkbox');
  }
  
  ngOnInit(): void { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.headerTemplates.changes.subscribe(
        change => {
          this.headers = change.toArray();
          for (let i = 0; i < this.headers.length; ++i)
            this.displayedDataColumnsList.push(`${i}`);
        }
      );
      this.headerTemplates.notifyOnChanges();

      this.rowTemplates.changes.subscribe(
        change => {
          this.rows = change.toArray().map(
            (row, id) => {
              this.rowExpanded[id] = false;
              row.id = row.id ?? `${id}`;
              return row;
            }
          );
        }
      );
      this.rowTemplates.notifyOnChanges();
    });
  }

  toggle(rowId: string): void {
    this.rows.forEach(row => {
      const id = row.id;
      if (id === rowId) {
        // toggle row
        this.rowExpanded[id] = !this.rowExpanded[id];
        if (this.rowExpanded[id]) row.onOpened(id);
        else row.onClosed(id);
      } else {
        // other rows, notify on close
        if (this.rowExpanded[id]) row.onClosed(id);
        this.rowExpanded[id] = false;
      }
    });
  }

  isRowExpanded(rowId: string): MatExpansionPanelState {
    return this.rowExpanded[rowId]
      ? 'expanded'
      : 'collapsed';
  }
}